var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quill-editor-wrapper"},[_c('quill-editor',{ref:"quillEditor",attrs:{"options":_vm.editorOption},on:{"blur":_vm.onEditorBlur,"focus":_vm.onEditorFocus,"ready":_vm.onEditorReady,"change":_vm.onEditorChange},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }